// filepath: resources/assets/front/js/components/mobile-menu.js

export function initMobileMenu(element = document) {
  const mobileMenuButton = element.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = element.querySelector('[data-mobile-menu]');
  
  if (mobileMenuButton && mobileMenu) {
    // Vérifier si déjà initialisé
    if (mobileMenuButton.hasAttribute('data-mobile-menu-init')) {
      return;
    }
    
    mobileMenuButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
      
      // Toggle aria-expanded
      const isExpanded = !mobileMenu.classList.contains('hidden');
      mobileMenuButton.setAttribute('aria-expanded', isExpanded);
    });
    
    mobileMenuButton.setAttribute('data-mobile-menu-init', 'true');
    console.log('📱 Mobile menu initialized');
  }
}